import React from "react";

export default () => {
  return (
    <div className="loading-spinner" aria-live="polite">
      <span>Loading Results</span>
    </div>
  );
};
